import React, { useState } from 'react';

const Tabs = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(tabs[0]?.label || '');

  const handleTabClick = (label) => {
    setActiveTab(label);
  };

  return (
    <div>
      <ul className='nav nav-tabs nav-tabs-3' role='tablist'>
        {tabs.map((tab) => (
          <li
            role='presentation'
            className={activeTab === tab.label ? 'active' : ''}
            key={tab.label}
          >
            <a onClick={() => handleTabClick(tab.label)}>{tab.label}</a>
          </li>
        ))}
      </ul>
      <div className='tab-content'>
        {tabs.map((tab) =>
          activeTab === tab.label ? (
            <div key={tab.label} className='tab-panel'>
              {tab.content}
            </div>
          ) : null
        )}
      </div>
    </div>
  );
};

export default Tabs;
